<template xmlns:v-bind="http://www.w3.org/1999/xhtml"
          xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="finest-hour typewriter-font">
    <div v-if="showPrintPreview" class="squadron-print">
      <button class="back-to-sortie" @click="showPrintPreview = false">Back to sortie</button>
      <squadron v-for="activeSection in sectionsToPrint"
                v-bind:key="activeSection.name"
                :initial-squadron="activeSection"></squadron>
    </div>
    <div v-else-if="finestHour != null" class="campaign-container">
      <!--      <h3>{{ finestHour.lastSortie.germanSections }}</h3>-->
      <div class="squadron">
        <table>
          <tbody>
          <tr>
            <td>{{ finestHour.squadronNumber }} squadron</td>
            <td>{{ finestHour.group }}</td>
            <td>{{ finestHour.homeAirfield }}</td>
            <td>{{ finestHour.activeAircraftsCount }} {{ finestHour.aircraft }}</td>
            <td>{{ finestHour.aircraftsUnderRepairCount }} {{ finestHour.aircraft }}</td>
            <td>{{ finestHour.activePilots.length }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>Squadron #</th>
            <th>Group</th>
            <th>Home airfield</th>
            <th>Active aircrafts</th>
            <th>Under repair</th>
            <th>Active pilots</th>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="date">
        <h2>{{ finestHour.currentDate.format('LL') }}
          <button @click="finestHour.endSortie()">End sortie</button>
          <button @click="finestHour.autoplay()">Autoplay sortie</button>
          <button @click="finestHour.autoplayOneWeek()">Autoplay one week</button>
          <template v-if="finestHour.group.includes('13')">
            <span class="warning">4th roll ignored for sorties when Group 13</span>
          </template>
        </h2>
      </div>
      <!--    <div class="attribute">-->
      <!--      <div class="label">Squadron #:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.squadronNumber }} squadron</div>-->
      <!--    </div>-->
      <!--    <div class="attribute">-->
      <!--      <div class="label">Group:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.group }}</div>-->
      <!--    </div>-->
      <!--    <div class="attribute">-->
      <!--      <div class="label">Home Airfield:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.homeAirfield }}</div>-->
      <!--    </div>-->
      <!--    <div class="attribute">-->
      <!--      <div class="label">Active aircrafts:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.activeAircrafts.length}}-->
      <!--                         {{ finestHour.aircraft }}</div>-->
      <!--    </div>-->
      <!--    <div class="attribute" v-if="finestHour.aircraftsUnderRepair.length > 0">-->
      <!--      <div class="label">Aircrafts under repair:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.aircraftsUnderRepair.length}}-->
      <!--                         {{ finestHour.aircraft }}-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <div class="attribute" v-if="finestHour.destroyedAircrafts.length > 0">-->
      <!--      <div class="label">Destroyed aircrafts:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.destroyedAircrafts.length}}-->
      <!--                         {{ finestHour.aircraft }}</div>-->
      <!--    </div>-->
      <!--    <div class="attribute">-->
      <!--      <div class="label">Pilots:</div>-->
      <!--      <div class="dots"></div>-->
      <!--      <div class="value">{{ finestHour.activePilots.length }}-->
      <!--                         / {{ finestHour.pilots.length }}-->
      <!--      </div>-->
      <!--    </div>-->
      <div v-if="finestHour.lastSortie != null">
        <h3>Sortie</h3>
        <div class="attribute">
          <div class="label">Description:</div>
          <div class="dots"></div>
          <div class="value">{{ finestHour.lastSortie.description }}</div>
        </div>
        <!--      <div class="attribute">-->
        <!--        <div class="label">RAF strength:</div>-->
        <!--        <div class="dots"></div>-->
        <!--        <div class="value">{{ finestHour.lastSortie.rafStrength }}</div>-->
        <!--      </div>-->
        <!--      <div class="attribute">-->
        <!--        <div class="label">Mission type:</div>-->
        <!--        <div class="dots"></div>-->
        <!--        <div class="value">{{ finestHour.lastSortie.missionType }}</div>-->
        <!--      </div>-->
        <!--      <div class="attribute">-->
        <!--        <div class="label">Bomber count:</div>-->
        <!--        <div class="dots"></div>-->
        <!--        <div class="value">{{ finestHour.lastSortie.bomberCount }}</div>-->
        <!--      </div>-->
        <!--      <div class="attribute">-->
        <!--        <div class="label">Luftwaffe strength:</div>-->
        <!--        <div class="dots"></div>-->
        <!--        <div class="value">{{ finestHour.lastSortie.luftwaffeFighterCount }}</div>-->
        <!--      </div>-->
        <div class="attribute">
          <div class="label">Location:</div>
          <div class="dots"></div>
          <div class="value">{{ finestHour.lastSortie.location }}</div>
        </div>
        <div class="attribute">
          <div class="label">Notes:</div>
          <div class="dots"></div>
          <div class="value">{{ finestHour.lastSortie.notes || '–' }}</div>
        </div>
        <div class="attribute">
          <div class="label">Reinforcements:</div>
          <div class="dots"></div>
          <div class="value">
            <span v-if="finestHour.lastSortie.reinforcementsStatus" style="margin-right: 1rem;">
              {{ finestHour.lastSortie.reinforcementsStatus }}</span>
            <template v-if="finestHour.lastSortie.reinforcementsPossible">
              <button v-if="!finestHour.lastSortie.reinforcementsArrived"
                      @click="rollForReinforcement" style="margin-right: 0;">Roll for reinforcements
              </button>
              <template v-else="">
                <button @click="printReinforcementSquadron">Print squadron</button>
              </template>
            </template>
          </div>
        </div>
        <h3>Sortie results</h3>

        <div class="attribute">
          <div class="label">Destroyed aircrafts:</div>
          <div class="dots"></div>
          <div class="value">
            <div class="number-selection">
              <div :class="{ selected: finestHour.lastSortie.destroyedAircrafts == null
                        || finestHour.lastSortie.destroyedAircrafts === 0 }"
                   @click="finestHour.lastSortie.destroyedAircrafts = 0">0
              </div>
              <div v-for="(p,i) in finestHour.lastSortie.activeSlotsIDs"
                   v-bind:key="p.id"
                   @click="finestHour.lastSortie.destroyedAircrafts = (i + 1)"
                   :class="{ selected: i + 1 === finestHour.lastSortie.destroyedAircrafts }">
                {{ i + 1}}
              </div>
            </div>
          </div>
        </div>
        <div class="attribute">
          <div class="label">Damaged aircrafts:</div>
          <div class="dots"></div>
          <div class="value">
            <div class="number-selection">
              <div :class="{ selected: finestHour.lastSortie.damagedAircrafts == null
                        || finestHour.lastSortie.damagedAircrafts === 0 }"
                   @click="finestHour.lastSortie.damagedAircrafts = 0">0
              </div>
              <div v-for="(p,i) in finestHour.lastSortie.activeSlotsIDs"
                   v-bind:key="p.id"
                   @click="finestHour.lastSortie.damagedAircrafts = (i + 1)"
                   :class="{ selected: i + 1 === finestHour.lastSortie.damagedAircrafts }">
                {{ i + 1}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>
        <div class="text">
          Squadron <small>(Active pilots are in yellow)</small>
        </div>
        <div class="actions">
          <button @click="printSquadron">Print British squadron</button>
          <button @click="printEnemySquadron">Print German squadron</button>
        </div>
      </h3>
      <div class="squadron-composition flex-v">
        <table>
          <colgroup>
            <col width="25%">
            <col width="25%">
            <col width="25%">
            <col width="25%">
          </colgroup>
          <thead>
          <tr>
            <th colspan="2">{{ finestHour.squadron[0].name }}</th>
            <th colspan="2">{{ finestHour.squadron[1].name }}</th>
          </tr>
          <tr>
            <th>{{ finestHour.squadron[0].sections[0].name }} section</th>
            <th>{{ finestHour.squadron[0].sections[1].name }} section</th>
            <th>{{ finestHour.squadron[1].sections[0].name }} section</th>
            <th>{{ finestHour.squadron[1].sections[1].name }} section</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <ul>
                <li v-for="squadronSlot in finestHour.squadron[0].sections[0].squadronSlots"
                    v-bind:key="squadronSlot.id">
                  <finest-hour-squadron-composition-pilot
                    :finest-hour="finestHour"
                    :is-active="finestHour.lastSortie.activeSlotsIDs.includes(squadronSlot.id)"
                    :squadronSlot="squadronSlot"></finest-hour-squadron-composition-pilot>
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li v-for="squadronSlot in finestHour.squadron[0].sections[1].squadronSlots"
                    v-bind:key="squadronSlot.id">
                  <finest-hour-squadron-composition-pilot
                    :finest-hour="finestHour"
                    :is-active="finestHour.lastSortie.activeSlotsIDs.includes(squadronSlot.id)"
                    :squadronSlot="squadronSlot"></finest-hour-squadron-composition-pilot>
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li v-for="squadronSlot in finestHour.squadron[1].sections[0].squadronSlots"
                    v-bind:key="squadronSlot.id">
                  <finest-hour-squadron-composition-pilot
                    :finest-hour="finestHour"
                    :is-active="finestHour.lastSortie.activeSlotsIDs.includes(squadronSlot.id)"
                    :squadronSlot="squadronSlot"></finest-hour-squadron-composition-pilot>
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li v-for="squadronSlot in finestHour.squadron[1].sections[1].squadronSlots"
                    v-bind:key="squadronSlot.id">
                  <finest-hour-squadron-composition-pilot
                    :finest-hour="finestHour"
                    :is-active="finestHour.lastSortie.activeSlotsIDs.includes(squadronSlot.id)"
                    :squadronSlot="squadronSlot"></finest-hour-squadron-composition-pilot>
                </li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <h3>Reserves</h3>
      <div class="reserves">
        <div class="pilot" v-for="p in finestHour.unassignedPilots" v-bind:key="p.id">
          {{ p.name }} <br> {{ p.rank }} <br> <b>{{ p.quality }}</b>
        </div>
        <p v-if="finestHour.unassignedPilots.length === 0">No pilots in reserve.</p>
      </div>
      <template v-if="finestHour.inactivePilots.length > 0">
        <h3>Out of action</h3>
        <div class="inactive-pilots disabled-cell">
          <div class="category" v-for="cat in finestHour.inactivePilotsByStatus"
               v-bind:key="cat.name">
            <div class="header">{{ cat.name }}
              <span v-if="cat.pilots.length > 0">({{cat.pilots.length}})</span>
            </div>
            <div class="pilots">
              <ul>
                <li v-for="p in cat.pilots" v-bind:key="p.id">
                  {{ p.name }} <br> {{ p.rank }} <br> <b>{{ p.quality }}</b>
                  <template v-if="p.backOn"><br><small>Back on {{ moment(p.backOn).format('LL')
                                                       }}</small></template>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
      <div>
        <div class="past-sorties" v-if="finestHour.sorties.length > 1">
          <h3>Past sorties</h3>
          <table>
            <thead>
            <th>Date</th>
            <th>RAF strength</th>
            <th>Mission type</th>
            <th>Bomber count</th>
            <th>Luftwaffe strength</th>
            <th>Luftwaffe aircrafts</th>
            <th>Notes</th>
            <th>Daily Events</th>
            <th>Log</th>
            </thead>
            <tbody>
            <template v-for="sortie in finestHour.sorties.slice(1)">
              <tr v-bind:key="sortie.id">
                <td>{{ sortie.date.format('L') }}</td>
                <td>{{ sortie.rafStrength }}</td>
                <td>{{ sortie.missionType }}</td>
                <td :class="{ 'disabled-cell': sortie.bomberCount === 0
            || sortie.missionType.includes('bounce')
            || sortie.missionType.includes('vectored') }">
            <span v-show="sortie.bomberCount > 0
            && !sortie.missionType.includes('bounce')
            && !sortie.missionType.includes('vectored')">
              {{ sortie.bomberCount }} x {{ sortie.bomberType }}</span></td>
                <td :class="{ 'disabled-cell': sortie.missionType.includes('unescorted')}">
              <span v-if="!sortie.missionType.includes('unescorted')
              && !sortie.missionType.includes('vectored')">
                {{ sortie.luftwaffeFighterCount }}</span>
                  <span v-else-if="!sortie.missionType.includes('unescorted')">
                One reconnaissance aircraft</span>
                </td>
                <td :class="{ 'disabled-cell': sortie.missionType.includes('unescorted')}">
                  <template v-if="!sortie.missionType.includes('unescorted')">
                    <template v-if="(sortie.luftwaffeFighterCount === 'None'
              && !sortie.missionType.includes('vectored'))">–
                    </template>
                    <template v-else="">
              <span v-if="!sortie.missionType.includes('unescorted')
                && !sortie.missionType.includes('vectored')">
                {{ sortie.escortType }}
              </span>
                      <span v-else="">{{ sortie.reconnaissanceType }}</span>
                    </template>
                  </template>
                </td>
                <td :class="{ 'disabled-cell': sortie.notes == null }">{{ sortie.notes }}</td>
                <td>{{ sortie.otherDailyEvents }}
                  <template v-if="sortie.otherDailyEventsResult != '–'">
                    <br><i>{{ sortie.otherDailyEventsResult }}</i>
                  </template>
                </td>
                <td>
                  <ul>
                    <li v-for="entry in sortie.log" v-bind:key="entry.id">
                      {{ entry.description }}
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <p>
        <button @click="backToCampaignCreation">New
                                                campaign
        </button>
        <!--        <button @click="reset()">Reset campaign</button>-->
        <!--        <button @click="exportCampaign()">Export campaign</button>-->
        <!--        <label class="btn" for="import_file">-->
        <!--          <input id="import_file"-->
        <!--                 type="file"-->
        <!--                 @change="importCampaign">Import campaign</label>-->
      </p>
    </div>
    <div v-else="" class="new-campaign-container">
      <h2>Welcome to the Bag the Hun Finest Hour campaign manager.</h2>
      <h3>What's your squadron #?</h3>
      <input v-model="newCampaign.squadronNumber" type="number"
             placeholder="Leave blank for random">
      <h3>What's your group?</h3>
      <select v-model="newCampaign.groupID">
        <option :value="null">- Random -</option>
        <option v-for="group in groups"
                v-bind:key="group.id"
                :value="group.id">{{group.name}}
        </option>
      </select>
      <template v-if="newCampaign.groupID != null">
        <h3>What's your home airfield?</h3>
        <select v-model="newCampaign.homeAirfield">
          <option value="">- Random -</option>
          <option v-for="homeAirfield in homeAirfields[newCampaign.groupID]
            .reduce((mem, x) => mem.includes(x) ? mem : [...mem, x], [])"
                  v-bind:key="homeAirfield"
                  :value="homeAirfield">{{homeAirfield}}
          </option>
        </select>
      </template>
      <h3>What type of aircraft is the squadron using?</h3>
      <select v-if="newCampaign.groupID != null"
              v-model="newCampaign.aircraft">
        <option :value="null">- Random -</option>
        <option v-for="aircraft in aircrafts[newCampaign.groupID]
          .reduce((mem, x) => mem.includes(x) ? mem : [...mem, x], [])"
                v-bind:key="aircraft"
                :value="aircraft">{{aircraft}}
        </option>
      </select>
      <select v-else=""
              v-model="newCampaign.aircraft">
        <option :value="null">- Random -</option>
        <option v-for="aircraft in Object.values(aircrafts)
        .reduce((mem, group) => [...mem, ...group].reduce((mem, x) => mem.includes(x)
          ? mem : [...mem, x], []), [])"
                v-bind:key="aircraft"
                :value="aircraft">{{aircraft}}
        </option>
      </select>
      <h3>How many aircraft are allocated to the squadron?</h3>
      <input v-model="newCampaign.numberOfAircrafts" type="number"
             placeholder="Leave blank for random">
      <h3>How many pilots are in the squadron?</h3>
      <input v-model="newCampaign.originalNumberOfPilots" type="number"
             placeholder="Leave blank for random">

      <button class="btn-lg"
              @click="createCampaign()">Create campaign
      </button>
    </div>
  </div>

</template>

<script type="text/babel">
  import axios from 'axios';
  import FinestHour from '@/models/FinestHour';
  import FinestHourSquadronCompositionPilot
    from '@/components/FinestHourSquadronCompositionPilot.vue';
  import moment from 'moment';
  import Groups from '@/models/finestHour/Groups';
  import HomeAirfields from '@/models/finestHour/HomeAirfields';
  import Aircrafts from '@/models/finestHour/Aircrafts';
  import Squadron from '@/components/Squadron.vue';

  export default {
    components: {
      Squadron,
      FinestHourSquadronCompositionPilot,
    },
    data() {
      return {
        aircrafts: Aircrafts,
        finestHour: null,
        groups: Groups,
        homeAirfields: HomeAirfields,
        newCampaign: {
          aircraft: null,
          numberOfAircrafts: null,
          originalNumberOfPilots: null,
          squadronNumber: null,
          groupID: null,
          homeAirfield: null,
        },
        sectionsToPrint: null,
        showPrintPreview: false,
        moment,
      };
    },
    methods: {
      async createCampaign() {
        window.localStorage.showNotificationOnLoad = true;
        if (this.newCampaign.groupID != null) {
          this.newCampaign.group = Groups.find((x) => x.id === this.newCampaign.groupID).name;
        }
        this.finestHour = new FinestHour(this.newCampaign);
        const response = await axios.post('http://apps.iwouldliketorage.com:49160/api/finestHours/', {
          json: this.finestHour.toJSON(),
        });
        window.localStorage.uuid = response.data.uuid;
        window.location.href = `${window.location.href}?id=${response.data.uuid}`;
      },
      backToCampaignCreation() {
        [window.location.href] = window.location.href.split('?');
      },
      reset() {
        window.localStorage.removeItem('finestHour');
        this.finestHour = new FinestHour();
      },
      exportCampaign() {
        if (window.localStorage.getItem('finestHour') != null) {
          this.download(window.localStorage
            .getItem('finestHour'), 'finest-hour.json', 'application/json');
        }
      },
      importCampaign(e) {
        const reader = new window.FileReader();
        reader.onload = (event) => {
          const data = event.target.result;
          window.localStorage.setItem('finestHour', data);
          window.location.reload();
        };
        reader.readAsText(e.target.files[0]);
      },
      download(data, filename, type) {
        const file = new Blob([data], { type });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, filename);
        } else { // Others
          const a = document.createElement('a');
          const url = URL.createObjectURL(file);
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      },
      printSquadron() {
        this.sectionsToPrint = this.finestHour.activeSections;
        this.showPrintPreview = true;
      },
      printEnemySquadron() {
        this.sectionsToPrint = this.finestHour.lastSortie.germanSections;
        this.showPrintPreview = true;
      },
      printReinforcementSquadron() {
        this.sectionsToPrint = this.finestHour.lastSortie.germanReinforcementSections;
        this.showPrintPreview = true;
      },
      rollForReinforcement() {
        this.finestHour.rollForReinforcement();
      },
    },
    async beforeMount() {
      const { search } = window.location;
      const params = new URLSearchParams(search);
      const id = params.get('id');
      if (id) {
        const response = await axios.get(`http://apps.iwouldliketorage.com:49160/api/finestHours/${id}`);
        window.localStorage.finestHour = response.data.json;
        this.finestHour = FinestHour.load();
      }
    },
    mounted() {
      if (window.localStorage.showNotificationOnLoad) {
        window.localStorage.removeItem('showNotificationOnLoad');
        setTimeout(() => {
          this.$notify({
            group: 'foo',
            title: 'Make sure you bookmark this page!',
            text: 'This is the only way you\'ll be able to open this campaign later so make sure you save the address.',
            duration: -1,
          });
        }, 250);
      }
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../vars";

  h1 {
    display: flex;
    align-items: center;

    button {
      margin-left: 1rem;
    }
  }

  h3 {
    display: flex;
    align-items: center;

    .text {
      flex-grow: 1;
    }

    .actions {

    }
  }

  button, .btn {
    padding: 0.5rem 1rem;
    background-color: #fff;
    border-radius: 0.4rem;
    border: solid 0.1rem $border-color;
    box-shadow: 0.2rem 0.2rem 0.5rem #00000011;
    margin-right: 1rem;
    cursor: pointer;
    font-size: 1.2rem;
    font-family: john-doe, sans-serif;
    font-weight: 700;
    font-style: normal;

    &.btn-lg {
      padding: 0.8rem 1.6rem;
      font-size: 1.4rem;
      margin-top: 4rem;
    }

    input[type=file] {
      width: 0;
    }
  }

  .squadron {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 10;

    table {
      border-spacing: 0;
      border: solid 0.1rem $border-color;
      width: 100%;
      background: #fff;
      box-shadow: 0 0 1.6rem #00000033;

      td, th {
        padding: 1rem;
        text-align: center;
        border-right: solid 0.1rem $border-color;;
      }

      td {
        padding-bottom: 0.6rem;
        font-size: 1.2em;
        font-weight: 900;
      }

      th {
        padding-top: 0.6rem;
        padding-bottom: 1.6rem;
        font-weight: 400;
      }
    }
  }

  .attribute {
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;
    height: 2rem;

    .label {
    }

    .dots {
      padding-top: 0.8rem;
      flex-grow: 1;
      border-bottom: dotted 0.1rem #00000033;
      margin-left: 0.6rem;
      margin-right: 0.6rem;
    }

    .value {
      font-weight: 700;
    }
  }

  .flex-v {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .finest-hour {
    padding: 1.6rem;
  }

  .campaign-container {
    margin-top: 7rem;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 0;
  }

  .squadron-composition {
    table {
      border-spacing: 0;
      border: solid 0.1rem $border-color;
      width: 100%;

      th {
        padding: 1rem;
      }

      th, td {
        border-left: solid 0.1rem $border-color;
        border-top: solid 0.1rem $border-color;

        &:first-of-type {
          border-left: 0;
        }
      }

      thead {
        tr:first-of-type {
          th, td {
            border-top: none;
            font-size: 1.1em;
          }
        }
      }
    }
  }

  .past-sorties {
    table {
      border-spacing: 0;
      border: solid 0.1rem $border-color;
      width: 100%;

      tbody {
        tr {
          background-color: #00000000;

          &:nth-of-type(odd) {
            background-color: #00000007;
          }
        }
      }

      th, td {
        padding: 0.6rem 1rem;
        border-left: solid 0.1rem $border-color;
        border-top: solid 0.1rem $border-color;
        vertical-align: top;

        &:first-of-type {
          border-left: 0;
        }

        ul {
          list-style: disc;
          margin-left: 1.5rem;
        }
      }

      thead {
        tr:first-of-type {
          th, td {
            border-top: none;
            font-size: 1.1em;
          }
        }
      }
    }
  }

  .disabled-cell {
    background-image: repeating-linear-gradient(-45deg,
      transparent 0 2px,
      transparentize($text-color, 0.6) 2px 4px);
  }

  .number-selection {
    display: flex;

    > div {
      padding: 0.3rem 1rem;

      &.selected {
        border-radius: 1rem;
        background-color: $text-color;
        color: #fff;
        cursor: pointer;
      }

      &.disabled {
        pointer-events: none;
        cursor: not-allowed;
        color: transparentize($text-color, 0.5);
      }
    }
  }

  .reserves {
    display: flex;
    flex-wrap: wrap;

    .pilot {
      padding: 1rem;
      flex-basis: 20%;
      flex-grow: 0;
      flex-shrink: 0;
      border: solid 0.1rem $border-color;
      margin-top: -0.1rem;
      margin-left: -0.1rem;
    }
  }

  .inactive-pilots {
    display: flex;
    border: solid 0.1rem $border-color;

    .category {
      flex-basis: 16.66%;
      flex-grow: 0;
      flex-shrink: 0;
      border-right: solid 0.1rem $border-color;

      &:last-of-type {
        border-right: 0;
      }

      .header {
        font-weight: 900;
        padding: 1rem;
        background: #fff;
      }

      .pilots {
        ul {
          margin: 0;
          padding: 0;
          list-style: none;
          overflow-y: auto;
          max-height: 22rem;

          li {
            border-top: solid 0.1rem transparentize($border-color, 0.5);
            margin: 0;
            padding: 1rem;
            background: #fff;
          }
        }
      }
    }
  }

  .warning {
    font-size: 1rem;
    font-weight: 400;
    color: red;
    border: solid 0.1rem red;
    border-radius: 0.6rem;
    padding: 0.5rem 1rem;
    display: inline-block;
    margin-left: 2rem;
    margin-top: 1rem;
  }

  .new-campaign-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    select, input {
      /*margin: auto;*/
      min-width: 20rem;
      padding: 0.6em 1.2rem;
      border-radius: 0.6rem;
      border: solid 0.1rem #cccccc;
      font-size: 1.5rem;

      option {
        padding: 0.6em 1.2rem;

      }
    }
  }

  .squadron-print {
    .back-to-sortie {
      position: absolute;
      right: 1.6rem;
      top: 2.8rem;
    }
  }

  @media print {
    .squadron-print {
      .back-to-sortie {
        display: none;
      }
    }
  }
</style>
